if (!customElements.get('prive-product-form')) {
  customElements.define(
    'prive-product-form',
    class PriveProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.submitButton = this.form.querySelector('[type="submit"]');
        this.errorWrapper = this.querySelector('.prive-product-form__error');
        this.errorMessage = this.querySelector('.prive-product-form__error-message');
        this.spinner = this.querySelector('.prive-product-form__spinner');

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (this.submitButton.classList.contains('loading')) return;

        this.handleErrorMessage();
        this.setLoading(true);

        const formData = new FormData(this.form);

        fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description || response.message);
              return;
            }

            this.updateCartCount(response);
            this.openCartDrawer();
          })
          .catch(() => {
            this.handleErrorMessage('Unable to add this product to your bag. Please try again.');
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;

        this.submitButton.classList.toggle('loading', isLoading);
        this.submitButton.setAttribute('aria-disabled', isLoading);
        this.spinner?.classList.toggle('hidden', !isLoading);
      }

      handleErrorMessage(message = false) {
        if (!this.errorWrapper || !this.errorMessage) return;

        this.errorWrapper.toggleAttribute('hidden', !message);
        if (message) this.errorMessage.textContent = message;
      }

      updateCartCount(response) {
        const itemCount = response.item_count;
        const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
        const bubbleWrapper = document.querySelector('#cart-icon-bubble .cart-count-bubble');

        if (typeof itemCount === 'number' && bubble) {
          bubble.textContent = itemCount < 100 ? itemCount : '';
        } else if (typeof itemCount === 'number' && itemCount > 0 && bubbleWrapper == null) {
          const cartIcon = document.getElementById('cart-icon-bubble');
          if (!cartIcon) return;

          const countNode = document.createElement('div');
          countNode.className = 'cart-count-bubble';
          countNode.innerHTML = `<span aria-hidden="true">${itemCount < 100 ? itemCount : ''}</span>`;
          cartIcon.appendChild(countNode);
        }
      }

      openCartDrawer() {
        const hsCart = document.querySelector('.hs-cart, .hs-site-cart-popup-layout');
        const overlay = document.querySelector('.hs-bg-slide-cart');

        if (hsCart) {
          hsCart.classList.add('hs-active', 'active', 'open');
          hsCart.style.display = '';
          document.body.classList.add('hs-cart-open', 'overflow-hidden');
          if (overlay) overlay.style.display = 'block';
          if (typeof window.HS_SLIDE_CART_OPENED === 'function') window.HS_SLIDE_CART_OPENED();
          return;
        }

        const cartNotification = document.querySelector('cart-notification');
        if (cartNotification && typeof cartNotification.open === 'function') {
          cartNotification.open();
          return;
        }

        document.getElementById('cart-icon-bubble')?.click();
      }
    }
  );
}
